import {DocumentState, DocumentStoreInterface} from './state';
import {DocumentActions} from './actions';
import {PageResponseModel} from '@/models/Common';
import {CargoPlaceDto, DocumentModel} from '@/models/DocumentModel';
import {StoreOptions} from 'vuex';

export const DocumentModule = {
  state: () => DocumentState,
  actions: DocumentActions,
  mutations: {
    setListDocuments(state: DocumentStoreInterface, data: PageResponseModel<DocumentModel>) {
      state.listDocuments = data;
    },
    setDocumentById(state: DocumentStoreInterface, data: DocumentModel) {
      state.documentById = data;
    },
    setCargoPlace(state: DocumentStoreInterface, data: CargoPlaceDto) {
      state.cargoPlace = data;
    },
    setPhones(state: DocumentStoreInterface, data: {id: number, clientManager: string, presenter: string}) {
      state.phones = data;
    }
  }
}
